import { LogicNodeDefinition } from '../LogicNodeDefinition';

export interface LeverNodeState {
  isOn: boolean;
}

export const LeverNode: LogicNodeDefinition<LeverNodeState> = {
  type: 'LEVER',
  createDefaultState: () => ({ isOn: false }),
  process: (_input, state) => state?.isOn ?? false,
};
